import { useState } from 'react';
import './App.css';
import Picker from 'react-mobile-picker';

const selections = {
  hour: [
    'A99', 'A98', 'A97', 'A96', 'A95', 'A94', 'A93', 'A92', 'A91', 'A90',
    'A89', 'A88', 'A87', 'A86', 'A85', 'A84', 'A83', 'A82', 'A81', 'A80',
    'A79', 'A78', 'A77', 'A76', 'A75', 'A74', 'A73', 'A72', 'A71', 'A70',
    'A69', 'A68', 'A67', 'A66', 'A65', 'A64', 'A63', 'A62', 'A61', 'A60',
    'A59', 'A58', 'A57', 'A56', 'A55', 'A54', 'A53', 'A52', 'A51', 'A50',
    'A49', 'A48', 'A47', 'A46', 'A45', 'A44', 'A43', 'A42', 'A41', 'A40',
    'A39', 'A38', 'A37', 'A36', 'A35', 'A34', 'A33', 'A32', 'A31', 'A30',
    'A29', 'A28', 'A27', 'A26', 'A25', 'A24', 'A23', 'A22', 'A21', 'A20',
    'A19', 'A18', 'A17', 'A16', 'A15', 'A14', 'A13', 'A12', 'A11', 'A10',
    'A09', 'A08', 'A07', 'A06', 'A05', 'A04', 'A03', 'A02', 'A01',
    'BBB',
    'C01', 'C02', 'C03', 'C04', 'C05', 'C06', 'C07', 'C08', 'C09', 'C10',
    'C11', 'C12', 'C13', 'C14', 'C15', 'C16', 'C17', 'C18', 'C19', 'C20',
    'C21', 'C22', 'C23', 'C24', 'C25', 'C26', 'C27', 'C28', 'C29', 'C30',
    'C31', 'C32', 'C33', 'C34', 'C35', 'C36', 'C37', 'C38', 'C39', 'C40',
    'C41', 'C42', 'C43', 'C44', 'C45', 'C46', 'C47', 'C48', 'C49', 'C50',
    'C51', 'C52', 'C53', 'C54', 'C55', 'C56', 'C57', 'C58', 'C59', 'C60',
    'C61', 'C62', 'C63', 'C64', 'C65', 'C66', 'C67', 'C68', 'C69', 'C70',
    'C71', 'C72', 'C73', 'C74', 'C75', 'C76', 'C77', 'C78', 'C79', 'C80',
    'C81', 'C82', 'C83', 'C84', 'C85', 'C86', 'C87', 'C88', 'C89', 'C90',
    'C91', 'C92', 'C93', 'C94', 'C95', 'C96', 'C97', 'C98', 'C99',
  ],
};

function App() {
  const [desValue, setDesValue] = useState('BBB');
  const [pickerValue, setPickerValue] = useState({
    hour: 'BBB',
  });
  
  const show0 = (value) => {
    return String(value).padStart(2, '0');
  };

  const transforToDay = (value) => {
    const date = new Date();
    if (value === 'BBB') return show0(date.getDate());

    const tipo1 = value.substring(0, 1);
    const tipo2 = value.substring(1, 3);
    if (tipo1 === 'A') {
      date.setDate(date.getDate() - parseInt(tipo2));
    }
    if (tipo1 === 'C') {
      date.setDate(date.getDate() + parseInt(tipo2));
    }
    return show0(date.getDate());
  };

  const transforToText = (value) => {
    const date = new Date();
    let text1 = 'Hoje';
    if (value === 'BBB') {
      text1 = 'Hoje';
    }

    const tipo1 = value.substring(0, 1);
    const tipo2 = value.substring(1, 3);
    if (tipo1 === 'A') {
      if (tipo2 === '01') {
        text1 = 'Ontem';
      } else {
        text1 = `Há ${parseInt(tipo2)} dias`;
      }
      date.setDate(date.getDate() - parseInt(tipo2));
    }
    if (tipo1 === 'C') {
      if (tipo2 === '01') {
        text1 = 'Amanhã';
      } else {
        text1 = `Daqui ${parseInt(tipo2)} dias`;
      }
      date.setDate(date.getDate() + parseInt(tipo2));
    }
    const daysOfWeek = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
    const months = [
      "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];
    return (
      <div>
        <div className='classText1'>{text1}</div>
        <div className='classText2'>{daysOfWeek[date.getDay()]}</div>
        <div className='classText3'>{months[date.getMonth()]} {date.getFullYear()}</div>
      </div>
    );
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className='calendario2'>
          <Picker
            value={pickerValue}
            onChange={(value) => {
              setDesValue(value.hour);
              setPickerValue(value);
            }}
            wheelMode="natural"
            itemHeight={80}
            height={400}
          >
            {Object.keys(selections).map(name => (
              <Picker.Column key={name} name={name}>
                {selections[name].map(option => (
                  <Picker.Item key={option} value={option}>
                    <div className={`numerodata ${pickerValue.hour === option ? 'selected' : ''}`}>
                      {transforToDay(option)}
                    </div>
                  </Picker.Item>
                ))}
              </Picker.Column>
            ))}

            <Picker.Column key={1} name={2} id={'id_col'}>
              <Picker.Item key={1} value={10} id={'id_item'}>
                <div id={'id_div2'}>
                  {transforToText(desValue)}
                </div>
              </Picker.Item>
            </Picker.Column>
          </Picker>
        </div>
      </header>
    </div>
  );
}

export default App;


